/* eslint-disable react/jsx-indent */
import styled from 'styled-components';
import { Button } from '../../fuse-buttons/src/buttons';

const ButtonStyled = styled(Button).attrs({
	className: 'fuse-pagination__page-button',
	'data-testid': 'fuse-pagination__page-button',
})`
	& {
		background-color: var(--color-global-grey200);
		margin-right: var(--spacing-global-space3);
		width: var(--spacing-global-space9);
		height: var(--spacing-global-space9);
		border: none;
		padding: 0;
		font-weight: 500;
	}

	&:active {
		color: var(--color-global-black);
		background-color: var(--color-global-grey200);
		box-shadow: none;
	}

	&:hover:enabled {
		background-color: var(--color-global-grey200);
		border: 1px solid var(--color-global-grey500);
		box-shadow: none;
	}

	&:focus {
		outline: none;
	}

	&:focus-visible,
	&:focus-visible:enabled {
		outline: 2px solid var(--color-functional-focus);
		outline-offset: var(--spacing-global-space1);
		background-color: var(--color-global-grey200);
		border: 1px solid var(--color-global-grey500);
		box-shadow: none;
	}

	&:disabled,
	&.active-page:focus:enabled {
		color: var(--color-global-black);
		background-color: var(--color-global-grey200);
		border: 1px solid var(--color-global-black);
		cursor: unset;
	}
`;

export default ButtonStyled;
